export default __webpack_public_path__ + "static/media/Boots of Wild Furor.f691cafd.jpg";